import { ArrowLeftOutlined } from '@ant-design/icons';
import { useIntl, useLocation, useModel } from '@umijs/max';
import React from 'react';
import { getEnteredMerchantId } from '@/models/merchantWorkspace';
import styles from './index.less';

const BackToMerchantListMenuItem: React.FC = () => {
  const intl = useIntl();
  const { initialState } = useModel('@@initialState');
  // Subscribe to route changes so every navigation re-evaluates the flag —
  // this menu item lives inside ProLayout, which re-renders on route change.
  useLocation();
  const { exitWorkspace } = useModel('merchantWorkspace');

  // Read sessionStorage DIRECTLY instead of the model's derived isEntered:
  // after enterWorkspace the flag must be visible immediately, but the model
  // value only refreshes when its context chain (@@initialState → merchant →
  // merchantWorkspace) propagates — observed stale after a SuperAdmin acting-as
  // entry (button missing until F5; a full reload mounts fresh and reads the
  // storage correctly). A direct read is always in sync with what
  // app.tsx's guards and menuRender already read the same way.
  const userId =
    initialState?.currentUser?.id || initialState?.currentUser?.userid;
  if (getEnteredMerchantId(userId) === null) return null;

  return (
    <div className={styles.item} onClick={exitWorkspace}>
      <ArrowLeftOutlined className={styles.icon} />
      <span>
        {intl.formatMessage({
          id: 'component.merchantWorkspace.backToList',
          defaultMessage: 'Back to Merchant List',
        })}
      </span>
    </div>
  );
};

export default BackToMerchantListMenuItem;
